import { Space } from 'antd';
import React from 'react';

import { ApplicationRules } from './components/ApplicationRules';
import { ApplicationTables } from './components/ApplicationTables';
import styles from './index.module.scss';

export const ApplicationAndManagement = () => {
  // TODO: 預計獲取「育樂活動預約管理辦法」資料的API會在這call

  return (
    <Space
      direction="vertical"
      size="middle"
      className={styles.applicationAndManagement}
    >
      <ApplicationRules />
      <ApplicationTables />
    </Space>
  );
};
